import React from 'react';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';

const BusinessEstablishmentList = ({
  formData,
  handleOnOpenBusinessActivityModal,
  handleOnDeleteBusinessActivity,
  handleAdd,
}) => {
  const permissions = getJson('permissions');

  return (
    <>
      <span
        className="font-weight-bold"
        style={{
          fontSize: '1rem',
          marginLeft: '-0.938rem',
          marginRight: '-0.938rem',
        }}
      >
        Business Establishments
      </span>
      <table
        className="transaction-table table table-striped table-borderless table-sm mt-2"
        style={{ marginLeft: '-0.938rem', marginRight: '-0.938rem' }}
      >
        {_.get(formData, 'business_establishments', []).length > 0 ? (
          <>
            <thead>
              <tr>
                <th
                  className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                  width="55%"
                >
                  Name
                </th>
                <th
                  className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                  width="20%"
                >
                  Address
                </th>
                <th
                  className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                  width="25%"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {_.get(formData, 'business_establishments', []).map((item, i) => (
                <tr
                  key={`${i + 1}-businessName${
                    _.get(item, 'business_establishments') ||
                    _.get(item, 'transaction_history_id')
                  }`}
                >
                  <td>
                    {_.get(item, 'business_establishments') ||
                      _.get(item, 'attributes.name')}
                  </td>
                  <td>
                    {_.get(item, 'business_establishment_address') ||
                      _.get(item, 'attributes.address')}
                  </td>
                  <td className="d-flex">
                    <button
                      disabled={!Acl(permissions, ['EDIT OHP'])}
                      type="button"
                      className="btn btn-sm btn-primary cms-bg-color-primary p-0 rounded-circle mr-2 border-0 rounded-circle d-flex justify-content-center align-items-center text-center"
                      onClick={handleOnOpenBusinessActivityModal(item, 'edit')}
                      title="Edit Business Activity"
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    >
                      <i className="fas fa-sm fa-pen" />
                    </button>
                    <button
                      disabled={!Acl(permissions, ['EDIT OHP'])}
                      type="button"
                      className="btn btn-sm btn-danger p-0 rounded-circle border-0 rounded-circle d-flex justify-content-center align-items-center text-center"
                      onClick={handleOnDeleteBusinessActivity(item.id)}
                      title="Delete Business Activity"
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    >
                      <i className="fas fa-sm fa-trash-alt" />
                    </button>
                  </td>
                </tr>
              ))}
              {Acl(permissions, ['EDIT OHP']) && (
                <tr className="bg-white">
                  <td className="text-dark" width="150" colSpan={3}>
                    <button
                      className="border-0 bg-transparent font-weight-bold cms-text-primary py-2"
                      onClick={(e) => {
                        handleAdd(e);
                      }}
                      type="button"
                    >
                      + Add Business Establishments
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </>
        ) : (
          <tbody>
            <tr className="bg-white">
              <td className="d-flex align-items-center justitfy-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0">No Item Found</p>
                </div>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </>
  );
};

BusinessEstablishmentList.defaultProps = {
  formData: {},
};

BusinessEstablishmentList.propTypes = {
  formData: PropTypes.instanceOf(Object),
  handleOnOpenBusinessActivityModal: PropTypes.instanceOf(Function).isRequired,
  handleOnDeleteBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  handleAdd: PropTypes.instanceOf(Function).isRequired,
};

export default BusinessEstablishmentList;
